import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GlobalDataService } from 'src/app/services/global-data.service';
import { AccordionItem } from '../accordion/accordion.component';

interface SocialLinks {
  facebookPageURL: string;
  instagramAccountURL: string;
  linkedInProfileURL: string;
  pinterestURL: string;
  twitterPageURL: string;
  youtubeChannelURL: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  social: SocialLinks;
  currentYear: number = new Date().getFullYear();
  menus: AccordionItem[] = [];
  directionsLink: string;
  pageDisclaimer: string;
  pagePrivacyPolicy: string;
  pageTermsAndConditions: string;
  environment;
  sitemapLink: string =
    environment.cdn_url + 'sitemap/' + environment.mall_id + '.xml';

  constructor(private router: Router, private globalData: GlobalDataService) {
    this.environment = environment;

    this.globalData.dataChange.subscribe((value) => {
      this.updateMallData(value);
    });
  }

  /**
   * Update data & default page links when global data changes
   */
  updateMallData(data) {
    if (data.social) this.social = data.social;

    if (data.menus?.footer) this.menus = data.menus.footer;

    if (data.defaultPages) {
      if (
        data.defaultPages.pagesDisclaimer &&
        data.defaultPages.pagesDisclaimer.length > 0
      )
        this.pageDisclaimer = data.defaultPages.pagesDisclaimer;

      if (
        data.defaultPages.pagesPrivacyPolicy &&
        data.defaultPages.pagesPrivacyPolicy.length > 0
      )
        this.pagePrivacyPolicy = data.defaultPages.pagesPrivacyPolicy;

      if (
        data.defaultPages.pagesTermsAndConditions &&
        data.defaultPages.pagesTermsAndConditions.length > 0
      )
        this.pageTermsAndConditions = data.defaultPages.pagesTermsAndConditions;
    }

    if (data.general?.mallAddress)
      this.directionsLink = data.general.mallAddress;
  }

  /**
   * Expand accordion item
   */
  expandItem(item): void {
    if (item.expanded) {
      item.expanded = false;
    } else {
      this.menus.map((listItem) => {
        if (item.slug == listItem.slug) {
          listItem.expanded = !listItem.expanded;
        } else {
          listItem.expanded = false;
        }
        return listItem;
      });
    }
  }

  /**
   * Link to detail page dependant on path & target
   */
  linkToPage(item) {
    let url = item.path;
    if (url.indexOf('/') < 0) url = '/page/' + item.path;

    return url;
  }

  ngOnInit() {
    const initialMallData = this.globalData.getGlobalData();
    if (initialMallData) this.updateMallData(initialMallData);
  }
}
